import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import ClinicCommunityResourcesPrintView from "../views/ClinicCommunityResourcesPrintView";
import theme from "../constants/Theme";

export default function ClinicCommunityResourcesTemplate({ pageContext }) {
  const { clinic } = pageContext;

  const data = useStaticQuery(graphql`
    {
      communityResources: allDatoCmsCommunityResource {
        nodes {
          id
          title
          notes
          address
          city
          state
          zip
          category
          phone
          websiteUrl
          location {
            latitude
            longitude
          }
        }
      }
    }
  `);

  const communityResources = data.communityResources?.nodes || [];

  return (
    <ThemeProvider theme={theme}>
      <ClinicCommunityResourcesPrintView
        clinic={clinic}
        communityResources={communityResources}
      />
    </ThemeProvider>
  );
}

